define([
    'angular',
    './controllers/cancelAccount',
    './controllers/editProfileCtrl',
    '../services/fileUpload',
    '../site/services/settings',
    '../site/services/site',
    './services/profile',
    'ng-file-upload',
    'ngstorage',
    'rangy',
    'rangy-selectionsaverestore',
    'text-angular-sanitize',
    'textangular',
    './directives/infusionsoft',
], function (angular, cancelAccountController, editProfileCtrl) {
    'use strict';

    var app = angular.module('userApp', [
        'fileUploadService',
        'infusionsoftDirectives',
        'loginCheckServices',
        'ngStorage',
        'textAngular',
        'profileServices',
        'settingsServices',
        'siteServices',
        'ui.router',
        'directives',
    ]);

    app.controller(
        cancelAccountController.name,
        cancelAccountController.arguments
    );
    app.controller(editProfileCtrl.name, editProfileCtrl.arguments);
    app.config([
        '$stateProvider',
        '$locationProvider',
        function ($stateProvider, $location) {
            $location.html5Mode({
                enabled: true,
                requireBase: false,
            });
            $stateProvider
                .state('profile', {
                    abstract: true,
                })
                .state('profile.basic', {
                    url: Routing.generate('profile_basic', { _format: 'html' }),
                    title: 'Profile',
                    views: {
                        'body@': {
                            controller: 'editProfileCtrl',
                            templateUrl: Routing.generate('angular_partial', {
                                bundle: 'AppUser',
                                entity: 'Profile',
                                template: 'partials/basic.html',
                            }),
                        },
                    },
                })
                .state('profile.professional', {
                    url: Routing.generate('profile_professional', {
                        _format: 'html',
                    }),
                    title: 'Professional Profile',
                    views: {
                        'body@': {
                            controller: 'editProfileCtrl',
                            templateUrl: Routing.generate('angular_partial', {
                                bundle: 'AppUser',
                                entity: 'Profile',
                                template: 'partials/professional.html',
                            }),
                        },
                    },
                })
                .state('profile.welcome', {
                    url: Routing.generate('profile_welcome', {
                        _format: 'html',
                    }),
                    title: 'Welcome to Home Value Leads',
                    views: {
                        'body@': {
                            controller: 'editProfileCtrl',
                            templateUrl: Routing.generate('angular_partial', {
                                bundle: 'AppUser',
                                entity: 'Profile',
                                template: 'partials/onboarding.html',
                            }),
                        },
                    },
                });
        },
    ]);

    return app;
});
